export enum TechnologyVoteTypeEnum { 
    No = 0,
    Yes = 1,
    Super = 2
}